import { Row } from 'react-table';
import styles from './GroupEditorModal.module.scss';

export const columns = [
  {
    Header: 'Color',
    Cell: ({ row: { original: group } }: { row: Row<any> }) => (
      <div className={styles.center_cell}>
        {typeof group.color === 'string' ? (
          <div className={styles.color_block} style={{ backgroundColor: group.color }} />
        ) : (
          <>&mdash;</>
        )}
      </div>
    ),
  },
  {
    Header: 'Name',
    Cell: ({ row: { original: group } }: { row: Row<any> }) => {
      const value = typeof group.name === 'string' ? group.name : null;
      return (
        <p className={styles.nameColumn} title={value || null}>
          {value || <>&mdash;</>}
        </p>
      );
    },
  },
  {
    Header: 'Description',
    Cell: ({ row: { original: group } }: { row: Row<any> }) => {
      const value = typeof group.description === 'string' ? group.description : null;
      return (
        <p className={styles.descriptionColumn} title={value || null}>
          {value || <>&mdash;</>}
        </p>
      );
    },
  },
];
